import React from 'react';
import webapi from '../../../api/webapi';
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import ReCAPTCHA from "react-google-recaptcha";

import {NotificationContainer, NotificationManager} from 'react-notifications';

import 'react-notifications/lib/notifications.css';

const recaptchaRef = React.createRef();


class ContactUs extends React.Component {
    state = { name : '' }
    state = { email : '' }
    state = { subject : '' }
    state = { ShowSubmit : false }

    constructor(props, context) {
        super(props, context);
        //const recaptchaRef = React.createRef();
        this.state = {
            pageData: undefined
        };
    }

    onSubmit = () => {
        const recaptchaValue = recaptchaRef.current.getValue();
        this.props.onSubmit(recaptchaValue);
      }
    
    componentDidMount() {
        this.setState({ShowSubmit:false})

        if (new URLSearchParams(this.props.location.search).get("lang")!=null)
        {
            //console.log('LangFromURL: ',new URLSearchParams(this.props.location.search).get("lang"));
            //console.log('LangFromSubDomain: ',window.location.host.split(".")[0]);
            this.getLanguageInfo(new URLSearchParams(this.props.location.search).get("lang"));
            //console.log(this.state.LanguageInfo);
        }else{
            this.setState({LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}]});
            document.getElementsByTagName('html')[0].setAttribute("lang","Fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
            this.getPage();
        }

        //this.getPage();
        //fetch('https://api.ipify.org/?format=json')
        fetch('https://geolocation-db.com/json/')
            .then(response => {
                return response.json();
            }, "jsonp")
            .then(res => {
                this.setLog('pages/log/contactus/visit/'+res.IPv4.replaceAll('.',','))
                this.setState({ip : res.ip})
            })
            .catch(err => this.setLog('pages/log/contactus/visit/'+err));
    }

    async setLog(Data) {
        await webapi.post(Data);
    }


    async sendContact(URL,Data) {
        //console.log(Data);
        await webapi.post(URL,Data, 
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':"Basic "+ btoa("reza:WE15214HsA522")
                }
            }
        )
                    //.done(function (data) {console.debug(data);});        
    }

    async getLanguageInfo(LanguageCode){
        const responseResultlanguageinfo = await webapi.get('pages/LanguageInfo/'+LanguageCode);
        //console.log(responseResultlanguageinfo.data.length);
        //console.log(responseResultlanguageinfo.data);
        
        if (responseResultlanguageinfo!==undefined && responseResultlanguageinfo.data.length>0)
        {
            this.setState({LanguageInfo:responseResultlanguageinfo.data});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang", responseResultlanguageinfo.data[0].Code);
            document.getElementsByTagName('html')[0].setAttribute("dir", responseResultlanguageinfo.data[0].Direction);
        }
        else
        {
            this.setState({LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}]});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang","fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
        }
        this.getPage();
    }

    async getPage() {
        if (this.state.LanguageInfo)
        {
            const pageList = await webapi.get('pages/datapages/703/'+this.state.LanguageInfo[0].Code);
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }else{
            const pageList = await webapi.get('pages/datapages/703/fa');
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }
    
        const pageHtml = await webapi.get('pages/htmlpages/703/'+this.state.LanguageInfo[0].Code);   
        //console.log(bodyList);     
        this.setState({
            pageHtmlData: pageHtml.data
        });
    }

    sendButtonClick = event =>{
        event.preventDefault();
        let emailformat = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i
        if ((this.state.name)&&(this.state.name!=='')&&(this.state.name!==null))
        {
            if ((this.state.email)&&(this.state.email!=='')&&(this.state.email!==null)&&(emailformat.test(this.state.email)))
            {
                if ((this.state.subject)&&(this.state.subject!=='')&&(this.state.subject!==null))
                {
                    this.sendContact('contactus/send', 
                                        JSON.stringify  (
                                                            {  
                                                                Author:this.state.name,
                                                                Email:this.state.email,
                                                                Description:this.state.subject.replace(/(?:\r|\n|\r\n)/g, '<br>'),
                                                                IP:this.state.ip
                                                            }
                                        )
                    )
                    .then(async response => {
                        NotificationManager.success(this.state.pageData.length!==0 && this.state.pageData[0].F70311!== undefined?this.state.pageData[0].F70311:70311/*'پیام شما با موفقیت ارسال گردید'*/, this.state.pageData.length!==0 && this.state.pageData[0].F70310!== undefined?this.state.pageData[0].F70310:70310/*'ارسال پیام'*/,5000);
                    })
                    .catch(error => {
                        NotificationManager.error(this.state.pageData.length!==0 && this.state.pageData[0].F70313!== undefined?this.state.pageData[0].F70313:70313/*'خطا در ارسال پیام'*/, this.state.pageData.length!==0 && this.state.pageData[0].F70312!== undefined?this.state.pageData[0].F70312:70312/*'خطا'*/, 5000, () => {});
                    });

                    this.setState({name:''})
                    this.setState({email:''})
                    this.setState({subject:''})
                }
                else
                {
                    NotificationManager.warning(this.state.pageData.length!==0 && this.state.pageData[0].F70315!== undefined?this.state.pageData[0].F70315:70315/*'متن پیام خالی است'*/, this.state.pageData.length!==0 && this.state.pageData[0].F70314!== undefined?this.state.pageData[0].F70314:70314/*'ورود اطلاعات'*/, 5000);
                }
            }
            else
            {
                NotificationManager.warning(this.state.pageData.length!==0 && this.state.pageData[0].F70317!== undefined?this.state.pageData[0].F70317:70317/*'ایمیل وارد شده معتبر نمی باشد'*/, this.state.pageData.length!==0 && this.state.pageData[0].F70316!== undefined?this.state.pageData[0].F70316:70316/*'ورود اطلاعات'*/, 5000);
            }
        }
        else
        {
            NotificationManager.warning(this.state.pageData.length!==0 && this.state.pageData[0].F70319!== undefined?this.state.pageData[0].F70319:70319/*'نام و نام خانوادگی وارد نشده است'*/, this.state.pageData.length!==0 && this.state.pageData[0].F70318!== undefined?this.state.pageData[0].F70318:70318/*'ورود اطلاعات'*/, 5000);
        }
    }

    onnameChange = event=> {
        this.setState({name:event.target.value})
        //console.log(event.target.value);
    }

    onemailChange = event=> {
        this.setState({email:event.target.value})
        //console.log(event.target.value);
        //console.log(this.state.name);
    }

    onsubjectChange = event=> {
        this.setState({subject:event.target.value})
        //console.log(event.target.value);
    }

    ReCAPTCHAChanged= (value) =>{
        this.setState({ShowSubmit:true});
    }
    
    render() {
        if (this.state.LanguageInfo && this.state.pageData && this.state.pageHtmlData) {
            return  (
                <div>
                    <Header  LanguageInfo = {this.state.LanguageInfo}/>
                    <div className="container-fluid" id="innerpage_row_1">
                        <div className="container">
                            <h1 id="page_title">{this.state.pageData.length!==0 && this.state.pageData[0].F70300!== undefined?this.state.pageData[0].F70300:70300/*تماس با ما*/}</h1>
                        </div>
                    </div>

                    <div className="container-fluid"  id="contact_form">
                        <div className="container container_70">
                            <form >
                                <label htmlFor="name">{this.state.pageData.length!==0 && this.state.pageData[0].F70301!== undefined?this.state.pageData[0].F70301:70301/*نام و نام خانوادگی*/}</label>
                                <input  type="text" 
                                        id="name" 
                                        name="name" 
                                        placeholder={this.state.pageData.length!==0 && this.state.pageData[0].F70302!== undefined?this.state.pageData[0].F70302:70302/*"Your name..."*/}
                                        value={this.state.name || ''}
                                        onChange={this.onnameChange}
                                />

                                <label htmlFor="email">{this.state.pageData.length!==0 && this.state.pageData[0].F70303!== undefined?this.state.pageData[0].F70303:70303/*ایمیل*/}</label>
                                <input  type="email" 
                                        id="email" 
                                        name="email" 
                                        placeholder={this.state.pageData.length!==0 && this.state.pageData[0].F70304!== undefined?this.state.pageData[0].F70304:70304/*"Your email..."*/}
                                        value={this.state.email || ''}
                                        onChange={this.onemailChange}
                                />
                                    
                                <label htmlFor="subject">{this.state.pageData.length!==0 && this.state.pageData[0].F70305!== undefined?this.state.pageData[0].F70305:70305/*موضوع و متن پیام*/}</label>
                                <textarea   id="subject" 
                                            name="subject" 
                                            placeholder={this.state.pageData.length!==0 && this.state.pageData[0].F70306!== undefined?this.state.pageData[0].F70306:70306/*"Write something..."*/}
                                            value={this.state.subject || ''}
                                            onChange={this.onsubjectChange}
                                        >
                                </textarea>
                                {
                                    (!this.state.ShowSubmit)
                                    ?
                                    [
                                        
                                        <form className="captcha_div" onSubmit={this.onSubmit} >
                                            <ReCAPTCHA
                                                ref={recaptchaRef}
                                                sitekey="6LcmcjwbAAAAAMOmqXnKxl7I8t9gW1fgRFk8sodX"
                                                onChange={this.ReCAPTCHAChanged}
                                            />
                                        </form>
                                        ,
                                        <input  type="submit" 
                                                className="submit_button" 
                                                value={this.state.pageData.length!==0 && this.state.pageData[0].F70307!== undefined?this.state.pageData[0].F70307:70307/*"ارسال"*/} 
                                                onClick={this.sendButtonClick}
                                                disabled
                                        />   
                                    ]
                                    :
                                    <input  type="submit" 
                                            className="submit_button" 
                                            value={this.state.pageData.length!==0 && this.state.pageData[0].F70307!== undefined?this.state.pageData[0].F70307:70307/*"ارسال"*/} 
                                            onClick={this.sendButtonClick}
                                            
                                    />   
                                }
                                

                            </form>
                        </div>
                    </div>
                    <NotificationContainer/>
                    <Footer Lang = {this.state.LanguageInfo[0].Code}/>
                </div>  
            );
        } else {
            return  (
                        <div>
                        </div>
                    )
        }
    }
 }

 export default ContactUs;